import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * <AuthImage path="prestige-property/..." /> fetches an authenticated file as a blob.
 * Cleans up its object URL on unmount.
 */
export default function AuthImage({ path, className, alt = "" }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!path) return;
    let revoked = false;
    let objectUrl = null;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (revoked) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      } catch {
        setErr(true);
      }
    })();
    return () => {
      revoked = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (err) {
    return <div className={"bg-zinc-200 flex items-center justify-center text-[10px] text-zinc-500 " + className}>image</div>;
  }
  if (!src) {
    return <div className={"bg-zinc-100 animate-pulse " + className} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
